import React from 'react';
import {
    FlexDiv,
    Image,
    SpaceBetweenDiv,
} from '../../../design-system/containers';
import { TextDefault, TextTiny } from '../../../design-system/texts';
import { Heading2 } from '../../../design-system/headings';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { resourcePath } from '../../../../utils/helpers';
import DefaultTrans from '../../default-i18next-trans';

export const BlueButton = styled.button`
    margin-left: auto;
    color: white;
    background: linear-gradient(0deg, #377efc 0%, #7eb1f0 100%);
    border: 1px solid rgba(44, 94, 189, 0.3);
    border-radius: 4px;
    font-size: 13px;
    padding: 8px 24px;
`;

function RansomwareAttack() {
    const { t } = useTranslation('assessment');
    return (
        <FlexDiv column borderRadius={8} dropShadowAbove overflowHidden mt={24}>
            <FlexDiv
                backgroundColor={
                    'linear-gradient(180deg, #C63023 0%, #A82216 103.56%);'
                }
                column
            >
                <FlexDiv
                    backgroundColor="rgba(29, 30, 29, 0.05)"
                    justifyEnd
                    px={24}
                    py={16}
                >
                    <Image
                        alt={t('close')}
                        src={resourcePath(
                            '/static/img/assessment/ch2_close.png'
                        )}
                    />
                </FlexDiv>
                <SpaceBetweenDiv py={24} px={24} alignCenter $noWrap gap={16}>
                    <FlexDiv column gap={8}>
                        <Heading2 color="white">
                            {t('Your files have been encrypted!')}
                        </Heading2>
                        <TextDefault color="white">
                            <TextDefault
                                backgroundColor="rgba(255,255,255,0.1)"
                                padding={4}
                                borderRadius={4}
                                bold
                                color="white"
                                airy
                            >
                                71:59:05
                            </TextDefault>
                            {t('time left until your files are destroyed')}
                        </TextDefault>
                    </FlexDiv>
                    <Image
                        height={100}
                        alt={t('lock')}
                        src={resourcePath(
                            '/static/img/assessment/ch2_lock.png'
                        )}
                    />
                </SpaceBetweenDiv>
            </FlexDiv>
            <FlexDiv column padding={24}>
                <TextTiny mb={24}>
                    <DefaultTrans
                        translatedString={t('ch2_presentation_text')}
                    />
                </TextTiny>
                <BlueButton> {t('Next')}</BlueButton>
            </FlexDiv>
        </FlexDiv>
    );
}

export default RansomwareAttack;
